import List from "./pages/List";
import Wizard from "./pages/Wizard";
import Container from "./pages/Container";

const routes = [
  {
    path: "container/:id/*",
    element: Container,
    permissions: ["WAREHOUSE_MODULE"],
  },
  {
    path: "*",
    element: List,
    permissions: ["WAREHOUSE_MODULE"],
  },
  {
    path: ":id/*",
    element: Wizard,
    permissions: ["WAREHOUSE_MODULE"],
  },
];

export default routes;
